module.exports = ".title{\r\n    margin-top: 0.5rem;\r\n    margin-left: 0.5rem;\r\n}\r\n"